export default class EstatedStructures {
  constructor(obj) {
    if (obj.structures) {
      this.fips = obj.structures.fips;
      this.apn = obj.structures.apn;
      this.year_built = obj.structures.year_built;
      this.effective_year_built = obj.structures.effective_year_built;
      this.stories = obj.structures.stories;
      this.rooms_count = obj.structures.rooms_count;
      this.beds_count = obj.structures.beds_count;
      this.baths = obj.structures.baths;
      this.partial_baths_count = obj.structures.partial_baths_count;
      this.units_count = obj.structures.units_count;
      this.parking_type = obj.structures.parking_type;
      this.parking_spaces_count = obj.structures.parking_spaces_count;
      this.pool_type = obj.structures.pool_type;
      this.architecture_type = obj.structures.architecture_type;
      this.construction_type = obj.structures.construction_type;
      this.exterior_wall_type = obj.structures.exterior_wall_type;
      this.foundation_type = obj.structures.foundation_type;
      this.roof_material_type = obj.structures.roof_material_type;
      this.roof_style_type = obj.structures.roof_style_type;
      this.heating_type = obj.structures.heating_type;
      this.heating_fuel_type = obj.structures.heating_fuel_type;
      this.air_conditioning_type = obj.structures.air_conditioning_type;
      this.fireplaces = obj.structures.fireplaces;
      this.basement_type = obj.structures.basement_type;
      this.quality = obj.structures.quality;
      this.condition = obj.structures.condition;
      this.flooring_types = obj.structures.flooring_types;
      this.plumbing_fixtures_count = obj.structures.plumbing_fixtures_count;
      this.interior_wall_type = obj.structures.interior_wall_type;
      this.water_type = obj.structures.water_type;
      this.sewer_type = obj.structures.sewer_type;
      this.total_area_sq_ft = obj.structures.total_area_sq_ft;
      this.other_rooms = obj.structures.other_rooms;
      this.amenities = obj.structures.amenities;
    }
  }

  get hasAttachedGarage() {
    return (
      [
        "ATTACHED GARAGE",
        "BUILT-IN",
        "FINISHED ATTACHED",
        "UNFINISHED ATTACHED",
        "TUCKUNDER",
      ].indexOf(this.parking_type) > -1
    );
  }

  get fireplacesCount() {
    if (!this.fireplaces) {
      return 0;
    }
    if (this.fireplaces === "YES") {
      return 1;
    }
    return parseInt(this.fireplaces, 10);
  }

  get storiesCount() {
    if (!this.stories) {
      return 0;
    }
    if (
      this.stories === "1" ||
      this.stories.startsWith("1+") ||
      this.stories.startsWith("1.")
    ) {
      return 1;
    }
    if (
      this.stories === "2" ||
      this.stories.startsWith("S/E") ||
      this.stories.startsWith("S/F") ||
      this.stories.startsWith("S/L") ||
      this.stories.startsWith("B/L") ||
      this.stories.startsWith("2+") ||
      this.stories.startsWith("2.")
    ) {
      return 2;
    }
    return 0;
  }

  get hasUnfinishedBasement() {
    return (
      [
        "DAYLIGHT OR WALKOUT",
        "FULL BASEMENT",
        "FULL DAYLIGHT",
        "PARTIAL BASEMENT",
        "PARTIAL DAYLIGHT",
        "UNFINISHED BASEMENT",
        "YES",
      ].indexOf(this.basement_type) > -1
    );
  }

  get hasFinishedBasement() {
    return this.basement_type === "IMPROVED BASEMENT";
  }

  get hasCentralHeatingCooling() {
    return (
      [
        "CENTRAL",
        "YES",
        "REFRIGERATION",
        "PACKAGED UNIT",
        "ROOFTOP PACKAGED UNIT",
      ].indexOf(this.air_conditioning_type) > -1 ||
      this.heating_type === "HEAT PUMP"
    );
  }

  get hasCentralHeating() {
    return (
      ["FORCED AIR UNIT", "CENTRAL", "YES", "HEAT PUMP", "GAS"].indexOf(
        this.heating_type
      ) > -1
    );
  }

  get hasFloorOrWallFurnace() {
    return this.heating_type === "FLOOR OR WALL";
  }
}
